import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'shared-ui-cards-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.css'],
  standalone: false,
})
export class CardComponent implements OnInit {
  @Input() title = '';
  @Input() withoutBorders = false;

  constructor() {}

  ngOnInit(): void {}
}
